
export default {
  name: 'CrossSellingBanner',
  props: {
    imageDesktop:{
      type: Object,
      default: () => {}
    },
    imageMobile:{
      type: Object,
      default: () => {}
    },
    title:{
      type: String,
      default: ""
    },
    description:{
      type: String,
      default: ""
    },
    link:{
      type: String,
      default: ""
    },
    blogWhatsappMsg: {
      type: String,
      default: ""
    },
    button1Text:{
      type: String,
      default: ""
    },
    button1Link:{
      type: String,
      default: ""
    },
    button1BorderColor:{
      type: String,
      default: ""
    },
    button2Text:{
      type: String,
      default: ""
    },
    button2Link:{
      type: String,
      default: ""
    },
    button2BorderColor:{
      type: String,
      default: ""
    },
    remarksButtonText:{
      type: String,
      default: ""
    },
    remarksButtonBorderColor:{
      type: String,
      default: ""
    },
    remarksContent:{
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      disabledRemarksButton: true,
      showRemarksContent: false,
      blogWhatsappLink: '',
      whatsappUrl: 'https://api.whatsapp.com/send/?phone=85237051599&text=',
    }
  },
  computed: {
    computedLink() {
      if (process.client) {
        const link = this.blogWhatsappLink;
        return link
      }
      return null
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.blogWhatsappLink = this.generateBlogWhatsappLink(this.blogWhatsappMsg) || this.link || '';
    })
  },
  methods: {

    async handleBannerClicked(event) {

      const btnLink = event.currentTarget.href;

      if (this.isBlogSinglePage() && this.isTransitionLink(btnLink)) {
        // crossSellngBanner special handling in blog single page.
        return
      }

    },
    generateBlogWhatsappLink(blogWhatsappTemplateMsg) {
      if (!blogWhatsappTemplateMsg) {
        return null
      }
      const msg = this.composeWhatsappMsg(blogWhatsappTemplateMsg)
      return `${this.whatsappUrl}${encodeURIComponent(msg)}`;
    },
    composeWhatsappMsg(blogMsg) {
      let msg = blogMsg || '';
      const blogUrl = window.location.toString().split('?')[0];
      if (blogUrl) {
        msg = msg?.replace('{blog_url}', blogUrl)
      } else {
        try {
          msg = msg?.replace('[ {blog_url} ]', '')
          throw new Error("*** blogUrl not valid ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(error);
        }
      }
      const firstBlogCategoryDisplayName = this.getBlogFirstTag();
      if (firstBlogCategoryDisplayName) {
        msg = msg?.replace('{first_blog_category_display_name}', firstBlogCategoryDisplayName);
      } else {
        try {
          msg = msg?.replace('{first_blog_category_display_name}', '');
          throw new Error("*** firstBlogCategoryDisplayName not valid ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
      return msg
    },
    getBlogFirstTag() {
      const tag = document.querySelector('.blog-single .tags .tag');
      return tag?.innerText || '';
    },
    toggleRemarksButton() {
      this.showRemarksContent = !this.showRemarksContent
      this.jumpTo('.remarks-container')
    },

    jumpTo(theHash) {
      this.$nextTick(() => {
        const el = document.querySelector(theHash)
        if (el) {
          document.querySelector(theHash).scrollIntoView({behavior: 'smooth', block: 'start'})
        }
      })
    },

    isBlogSinglePage(){
      if(this.$route?.name?.includes('blog-slug')){
        return true;
      }
      else{
        return false;
      }
    },
    isTransitionLink(link) {
      return link?.includes('transition-checkout');
    },
  }
}
